<ng-container>
    <div class="flex gap">
        <div class="grid-3col input-grid-gaps align-items-center flex-2">
            <app-select-input
                [form]="form"
                id="serviceId"
                label="inputs.serviceId"
                [staticOptions]="store.services()"
                valueKey="id"
                labelKey="name"
            >
                <ng-template #item let-data>
                    <div class="flex gap-small">
                        <div
                            class="stripe"
                            [style]="'background-color: ' + data.color + ';'">
                        </div>
                        <div class="flex-column gap-xx-small">
                            <div>
                                {{ data.name }}
                            </div>
                            @if (data.description) {
                                <div class="font-size-x-small text-secondary">
                                    {{ data.description }}
                                </div>
                            }
                        </div>
                    </div>
                </ng-template>

                <ng-template #selectedItem let-data>
                    <div class="flex gap-small">
                        <div class="stripe" [style]="'background-color: ' + data.color + ';'"></div>
                        <div>{{ data.name }}</div>
                    </div>
                </ng-template>
            </app-select-input>
            <app-select-input
                [form]="form" id="workplaceId" label="inputs.workplaceId"
                [staticOptions]="workplaces()"
            ></app-select-input>
            <app-date-input [form]="form" id="validAt" label="inputs.validAt" timeType="midDay"></app-date-input>
        </div>
        <div class="flex flex-1 justify-content-end">
            <app-button (click)="print()" severity="secondary" label="common.print"
                [disabled]="(table?.selection()?.length || 0) <= 0"></app-button>
        </div>
    </div>

    <app-table
        [gridData]="store.data.getVouchers()"
        [refreshCallback]="store.api.getVouchers"
        [refreshCallbackFragment]="voucherWithPersonFrag"
        translatePrefix="folder.voucher.listTable."
        [additionalFilter]="additionalFilter()"
        [columns]="columns"
        (detailCallback)="detail($event)"
    >
    </app-table>
</ng-container>
